import $foreign from "./foreign.cjs";
var _hideModal = $foreign._hideModal;
var _showModal = $foreign._showModal;
var wrapNode = $foreign.wrapNode;
export { _hideModal, _showModal, wrapNode };
